import { inject, Injectable } from '@angular/core';
import {
  DsSnackbarService,
  DsSnackbarType,
} from '@design-system/feature/snackbar';
import { TranslateService } from '@ngx-translate/core';
import { AuthErrorPresenter } from './models';

@Injectable()
export class AuthHostErrorPresenterService implements AuthErrorPresenter {
  private readonly _snackbarService: DsSnackbarService =
    inject(DsSnackbarService);
  private readonly _translateService: TranslateService =
    inject(TranslateService);

  displayError(translationMarker = 'general.error_code.error'): void {
    const message = this._translateService.instant(translationMarker);
    this._snackbarService.queue(message, {
      type: DsSnackbarType.Error,
      duration: 20000,
    });
  }
}
